import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	matrimonyProfileId: string
	isVerified: boolean
}

export async function matrimonyProfileVerifyApi(
	payload: RequestDataShape,
	token?: null | string,
) {
	const endpoint = "/matrimony/profile/verify/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	return await requester.sendRequest(payload, token)
}
